<template>
  <div>
    <span :class="'md-title'">By conclusions</span>
    <table :class="'report-compliance'">
      <thead>
        <th :class="'md-size-20'"></th>
        <th :class="'md-size-20'">Quantity</th>
        <th :class="'md-size-30'">%</th>
      </thead>
      <tbody>
        <tr>
          <td :class="'md-size-20'">
            <b>U</b>: Unsatisfactory
          </td>
          <td> {{ unsatisfactoryRatingsAmount }} </td>
          <td> {{ unsatisfactoryRatingsPercentage }}%</td>
        </tr>
        <tr>
          <td :class="'md-size-20'">
            <b>A</b>: Adequate with exception
          </td>
          <td> {{ adequateRatingsAmount }} </td>
          <td> {{ adequateRatingsPercentage }}% </td>
        </tr>
        <tr>
          <td :class="'md-size-20'">
            <b>C</b>: Compliant
          </td>
          <td> {{ complianceRatingsAmount }} </td>
          <td> {{ Number(complianceRatingsPercentage) + Number(leftTo100Percente) }}% </td>
        </tr>
      </tbody>
    </table>

    <span :class="'md-title'">By Standard</span>
    <table :class="'report-compliance'">
      <thead>
        <th :class="'md-size-20'"></th>
        <th :class="'md-size-5'">U</th>
        <th :class="'md-size-5'">A</th>
        <th :class="'md-size-5'">C</th>
        <th :class="'md-size-20'">Findings</th>
        <th :class="'md-size-20'">Action Plan</th>
        <th :class="'md-size-10'">Deadline</th>
      </thead>
      <tbody>
        <tr v-for="(section, i) in listOfSections" :key="i" v-if="section.code !== 'final'">
          <th>{{ i + 1 }}. {{ section.label }}</th>
          <td :class="'text-center'">
            <md-icon v-if="section.rating.rating === 3">check</md-icon>
          </td>
          <td :class="'text-center'">
            <md-icon v-if="section.rating.rating === 2">check</md-icon>
          </td>
          <td :class="'text-center'">
            <md-icon v-if="section.rating.rating === 1">check</md-icon>
          </td>
          <td>
            <span v-if="section.rating.comment" :style="'word-break: break-word'">{{ section.rating.comment }}</span>
            <span v-else><i>No findings</i></span>
          </td>
          <td>
            <span v-if="section.rating.action_plan" :style="'word-break: break-word'">{{ section.rating.action_plan }}</span>
            <span v-else><i>No action plan</i></span>
          </td>
          <td>{{ section.rating.action_plan_deadline | date }}</td>
        </tr>
      </tbody>
      <tfoot>
        <th>Total</th>
        <td :class="'text-center'">
          {{ unsatisfactoryRatingsAmount }}
        </td>
        <td :class="'text-center'">
          {{ adequateRatingsAmount }}
        </td>
        <td :class="'text-center'">
          {{ complianceRatingsAmount }}
        </td>
        <td colspan="3"></td>
      </tfoot>
    </table>

    <span :class="'md-title'">Overall conclusions</span>
    <table :class="'report-compliance'">
      <thead>
        <th :class="'md-size-20'"></th>
        <th :class="'md-size-5'">U</th>
        <th :class="'md-size-5'">A</th>
        <th :class="'md-size-5'">C</th>
        <th :class="'md-size-20'">Findings</th>
      </thead>
      <tbody>
        <tr v-for="(section, i) in listOfSections" :key="i" v-if="section.code === 'final'">
          <th>Rating in Overall Section</th>
          <td :class="'text-center'">
            <md-icon v-if="section.rating.rating === 3">check</md-icon>
          </td>
          <td :class="'text-center'">
            <md-icon v-if="section.rating.rating === 2">check</md-icon>
          </td>
          <td :class="'text-center'">
            <md-icon v-if="section.rating.rating === 1">check</md-icon>
          </td>
          <td>
            <span v-if="section.rating.comment" :style="'word-break: break-word'">{{ section.rating.comment }}</span>
            <span v-else><i>No findings</i></span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { date, sections } from '@/filters'
  import { sectionStandardMap } from '@/filters/sectionStandard'

  export default {
    data() {
      return {
        sectionStandardMap
      }
    },

    computed: {
      adequateRatingsAmount() {
        return this.q.ratings.filter(rating =>
          rating.rating === 2 && rating.section !== 'review_comments' && rating.section !== 'final').length
      },

      adequateRatingsPercentage() {
        return this.totalRatings === 0 ? 0 : Number((this.adequateRatingsAmount / this.totalRatings) * 100).toFixed(0)
      },

      complianceRatingsAmount() {
        return this.q.ratings.filter(rating =>
          rating.rating === 1 && rating.section !== 'review_comments' && rating.section !== 'final').length
      },

      complianceRatingsPercentage() {
        return this.totalRatings === 0 ? 0 : Number((this.complianceRatingsAmount / this.totalRatings) * 100).toFixed(0)
      },

      findingsFor () {
        return sections(this.activeRating.section)
      },

      leftTo100Percente() {
        return this.totalRatings === 0 ? 0
          : 100 - Number(Number(this.unsatisfactoryRatingsPercentage) + Number(this.adequateRatingsPercentage) + Number(this.complianceRatingsPercentage))
      },

      listOfSections () {
        const sectionsArray = [];
        Object.entries(sectionStandardMap).forEach(([key, value]) =>
          sectionsArray.push({label: value, code: key})
        )

        sectionsArray.map(section => {
          section.rating = this.q.ratings.find(rating => rating.section === section.code) || {}
        })

        return sectionsArray
      },

      totalRatings() {
        return this.q.ratings.filter(rating =>
          rating.section !== 'review_comments' && rating.section !== 'final').length
      },

      unsatisfactoryRatingsAmount() {
        return this.q.ratings.filter(rating =>
          rating.rating === 3 && rating.section !== 'review_comments' && rating.section !== 'final').length
      },

      unsatisfactoryRatingsPercentage() {
        return this.totalRatings === 0 ? 0
          : Number((this.unsatisfactoryRatingsAmount / this.totalRatings) * 100).toFixed(0)
      },      
    },

    filters: {
      date,
      sections,
    },

    props: {
      q: {
        type: Object,
        default: () => {}
      }
    },
  }
</script>